global.api_url = 'https://api.anytrakk.com'
global.odometer_image_url = 'http://3.108.79.43:8003/storage/'
global.documents_image_url='https://documentsstorage.anytrakk.com/storage/'
global.company_documents_image_url = 'http://3.108.79.43:8080/storage/'
global.pincode_url = 'https://postalcodes.anyshipp.com'
global.privacy_policy_url = 'https://api.anytrakk.com/docs/Privacy_Policy_Trackyo.pdf'
global.privacy_policy_viewer = `https://docs.google.com/viewer?url=${global.privacy_policy_url}&embedded=true`
global.terms_of_service_url = 'https://api.anytrakk.com/docs/Terms_of_Service_Trackyo.pdf'
global.terms_of_service_viewer=`https://docs.google.com/viewer?url=${global.terms_of_service_url}&embedded=true`
global.billing_storage_url = 'http://3.108.79.43:8080/storage/public/'